import { Component, OnInit, OnDestroy, forwardRef, EventEmitter, Output } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as fromStore from '../../../store';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { INDRAAirportInputComponent } from '@ibe.components/booking/search/airport-input/airport-input.indra.component';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-select-airport-modal',
	templateUrl: './select-airport-modal.indra.component.html',
	styleUrls: ['./select-airport-modal.component.scss'],
	providers: [
		{
			/**
			 * Custom Control value accessor
			 */
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => INDRAAirportInputComponent),
			multi: true
		}
	]
})
export class INDRASelectAirportModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {

	isAlive = true;
	isLoading = true;
	airport;
	title = '';

	query = this.airport !== null ? this.airport : '';
	hasFocus = false;
	showAutocomplete = true;

	private loading$: Observable<boolean> = this.store.select(fromStore.getUserLoading);
	private activeInput$: Observable<string> = this.store.select(fromStore.getMiniIBEActiveInput);
	activeInput: string;
	
	private routeType$: Observable<string> = this.store.select(fromStore.getMiniIBERouteType);
	routeType: string;

	completeOptions = [];
	dataOptions = [];
	id = '';
	callback;

	searchRoutes$: Observable<any> = this.store.select(fromStore.getMiniIBESearchRoutes);
	searchRoutes;

	currentSearch$: Observable<any> = this.store.select(fromStore.getMiniIBECurrentSeachRoute);
	currentSearch: number;

	@Output()
	selected = new EventEmitter<any>();

	// required for ControlValueAccessor
	propagateChange = (_: any) => { };

	constructor(protected modalService: ModalService, private store: Store<fromStore.State>, private ibeAdminService: INDRAIbeAdminService) {
		super(modalService);
		this.activeInput$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.title = `${value === 'from' ? this.INDRA_getTranslation('bookingSearch.label.departure') : this.INDRA_getTranslation('bookingSearch.label.arrival')} ${this.INDRA_getTranslation('bookingSearch.text.airport')}`;
					this.activeInput = value === 'from' ? 'departure' : 'arrival';
				}
			});

		this.routeType$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.routeType = value;
					if (value == 'multicity') this.completeOptions = ['seach-region'];
				}
			});


		this.currentSearch$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => this.currentSearch = value);

		this.searchRoutes$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => this.searchRoutes = value);
	}

	ngOnInit() {
		if (this.data && this.data[0] && this.data[0].params && this.data[0].params.dataOptions) {
			this.dataOptions = this.data[0].params.dataOptions;
			this.id = this.data[0].params.id;
			this.callback = this.data[0].handleClose;
		}
		this.loading$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.isLoading = value;
		});
		this.airport = this.searchRoutes[this.currentSearch][this.activeInput];
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	/**
	 * Print airport name on input
	 */
	get INDRA_printAirportName() {
		if (this.airport && this.airport.location) {
			const airport = this.airport;
			// Check if airport name is diferent then city name
			const airportName = airport.location.city.toLowerCase() === airport.name.toLowerCase() ? '' : airport.name + ', ';
			return (
				airport.location.city + ', ' + airportName + airport.location.country
			);
		}
		if (this.airport && this.airport['type']) {
			return this.airport['value'].label;
		}
		return '';
	}
	
	INDRA_clearInput() {
		this.airport = '';
	}

	/**
	 * Print airport iata code on input
	 */
	INDRA_printAirportCode() {
		if (this.airport && this.airport.location) {
			const airport = this.airport;
			return airport.code;
		}
		if (this.airport && this.airport['type']) {
			return this.airport['value'].icon;
		}
		return '';
	}


	INDRA_printTitle() {
		return this.title;
	}

	INDRA_printLabel(): boolean {
		return !this.airport;
	}

	INDRA_handleInputBlur(e) {
		this.hasFocus = false;
		if (this.airport instanceof Object) {
			this.propagateChange(this.airport);
		}
	}

	INDRA_handleInputFocus(e) {
		this.hasFocus = true;
	}

	INDRA_handleInputChange(e) {
		this.query = e.target.value;
		this.propagateChange(e.target.value);
	}



	INDRA_handleSelect(e) {
		if (e !== null) {
			this.hasFocus = false;
			this.showAutocomplete = false;
		}

		if (e && e.type == 'recent-search') {
			let newSearchRoutes = Object.assign([], this.searchRoutes);
			if (this.searchRoutes.length >= this.currentSearch + 1) {
				newSearchRoutes = newSearchRoutes.map((cur, idx) => {
					if (idx === this.currentSearch) cur = e.value;
					return cur;
				});
			} else {
				newSearchRoutes.push(e.value);
			}

			this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
			this.store.dispatch(new MiniIBEActions.PutSearchRoute(newSearchRoutes));
		} else {

			this.writeValue(e);
			this.propagateChange(e);
		}

		if (e) {
			if (this.data && this.data[0] && this.data[0].handleClose) {
				this.data[0].handleClose(e);
			}
		}
		this.closeModal();
	}


	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched() { }

	writeValue(value: any) {
		this.airport = value;
	}
	closeModal() {
		this.modalService.close();
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
}
